// Kebab-case slugs are the document ids of the sound vocabulary collections
// (sound_tags / sound_instrument_types) — see seedSoundVocabulary.js. They are
// baked into sounds' tagIds and shipped in pack manifests, so they must stay
// stable once created; these helpers only shape *new* ids.

/**
 * Derive a kebab-case slug from a human label (e.g. "Hi-Hat" → "hi-hat").
 */
export function slugify(label: string): string {
    return label
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // strip diacritics left by NFD
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

/**
 * Whether a string is a valid vocabulary slug: lowercase alphanumeric groups
 * separated by single dashes, no leading/trailing dash.
 */
export function isValidSlug(value: string): boolean {
    return /^[a-z0-9]+(-[a-z0-9]+)*$/.test(value);
}
